// Delen vanuit een andere app (Android share target, spec T1 AC4): the shared text or link becomes an inbox task.
import { useEffect, useRef } from "react";
import { toast } from "sonner";
import { navigate } from "../lib/hooks";
import { captureTask } from "../lib/tasks";

/** Title from what was shared: the text, else the title, else the link. A link goes into the note. */
export function sharedTask(params: URLSearchParams): { title: string; notes: string | null } | null {
  const text = params.get("text")?.trim() ?? "";
  const title = params.get("title")?.trim() ?? "";
  let url = params.get("url")?.trim() ?? "";
  // Many apps put the link in the text field.
  const linkInText = text.match(/https?:\/\/\S+/)?.[0];
  if (!url && linkInText) url = linkInText;
  const textWithoutLink = linkInText ? text.replace(linkInText, "").trim() : text;
  const name = (textWithoutLink || title || url).slice(0, 500);
  if (!name) return null;
  return { title: name, notes: url && url !== name ? url : null };
}

export function ShareScreen() {
  const handled = useRef(false);
  useEffect(() => {
    if (handled.current) return;
    handled.current = true;
    const task = sharedTask(new URLSearchParams(window.location.search));
    void (async () => {
      if (task) {
        await captureTask(task.title, { notes: task.notes, source: "share" });
        toast("Bij Nieuw in Taken gezet");
      }
      // Replace: the back button should not share it a second time.
      navigate("/taken", { replace: true });
    })();
  }, []);
  return <main aria-busy className="min-h-dvh" />;
}
